import { createContext, useState } from 'react';

const useValue = () => {
    const [showPreferences, setShowPreferences] = useState(false);

    return {
        showPreferences,
        setShowPreferences,
    };
};

const PreferencesContext = createContext({} as ReturnType<typeof useValue>);

const PreferencesProvider = ({ children }: any) => {
    return <PreferencesContext.Provider value={useValue()}>{children}</PreferencesContext.Provider>;
};

export { PreferencesProvider, PreferencesContext };
